export default {"src":"/_next/static/media/geographyBg.0d366b02.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};